import type { RotasDoModulo } from '@/app/rotas';

import { PipeBoardPage } from './PipeBoardPage';
import { PipesPage } from './PipesPage';

/** Esteiras (P-EST-1): a lista das esteiras e o quadro de cada uma, com a gaveta. */
export const rotas: RotasDoModulo = {
  menu: { '/esteiras': PipesPage },
  moldura: [{ path: '/esteiras/:pipeId', element: <PipeBoardPage /> }],
};
